import axios from 'axios';
import {
  IUserCollection,
  IUserListParams,
  IUser,
  IChangeUserPasswordPayload,
  IChangeUserPasswordByCodePayload,
  IDeleteUserPayload,
  IRemoveUserSubdivisionPayload,
  IUpdateUserByAdminPayload,
  IUpdateUserPayload,
  IUserStats,
  IUserInventoryStats,
  IAddUserSubdivisionPayload,
  IChangeUserEmailPayload,
  IChangeUserPhonePayload,
  IConfirmUserEmailPayload,
  IConfirmUserPhonePayload,
  IUserInventoryStatsParams,
  IUserAssigneesParams,
  IUserAssigneeCollection,
  ICreateUserAssigneePayload,
  IDeleteUserAssigneePayload,
  IUserAssignee,
} from 'entities/User/User.models';

const basePath = 'user';

export const userTransport = {
  get: (params: IUserListParams): Promise<IUserCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<IUser> => axios.get(`${basePath}/${id}`),
  updateByAdmin: (payload: IUpdateUserByAdminPayload): Promise<IUser> => axios.patch(`${basePath}/by-admin`, payload),
  update: (payload: IUpdateUserPayload): Promise<IUser> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteUserPayload): Promise<IUser> => axios.delete(`${basePath}`, { data: payload }),
  changePassword: (payload: IChangeUserPasswordPayload): Promise<IUser> => axios.patch(`${basePath}/change-password`, payload),
  sendChangePasswordCodeByEmail: (): Promise<void> => axios.post(`${basePath}/password/email/send-code`),
  sendChangePasswordCodeByPhone: (): Promise<void> => axios.post(`${basePath}/password/phone/send-code`),
  changePasswordByEmailCode: (payload: IChangeUserPasswordByCodePayload): Promise<IUser> =>
    axios.patch(`${basePath}/password/email/change`, payload),
  changePasswordByPhoneCode: (payload: IChangeUserPasswordByCodePayload): Promise<IUser> =>
    axios.patch(`${basePath}/password/phone/change`, payload),
  addSubdivision: (payload: IAddUserSubdivisionPayload): Promise<IUser> => axios.patch(`${basePath}/add-subdivision`, payload),
  removeSubdivision: (payload: IRemoveUserSubdivisionPayload): Promise<IUser> =>
    axios.patch(`${basePath}/remove-subdivision`, payload),
  getStats: (): Promise<IUserStats> => axios.get(`${basePath}/stats`),
  getInventoryStats: (params?: IUserInventoryStatsParams): Promise<IUserInventoryStats> =>
    axios.get(`${basePath}/stats/inventory`, { params }),
  changeEmail: (payload: IChangeUserEmailPayload): Promise<void> => axios.post(`${basePath}/email/change`, payload),
  changePhone: (payload: IChangeUserPhonePayload): Promise<void> => axios.post(`${basePath}/phone/change`, payload),
  confirmEmail: (payload: IConfirmUserEmailPayload): Promise<void> => axios.post(`${basePath}/email/confirm`, payload),
  confirmPhone: (payload: IConfirmUserPhonePayload): Promise<void> => axios.post(`${basePath}/phone/confirm`, payload),
  getAssignees: (params: IUserAssigneesParams): Promise<IUserAssigneeCollection> => axios.get(`${basePath}/assignee`, { params }),
  createAssignee: (payload: ICreateUserAssigneePayload): Promise<IUserAssignee> => axios.post(`${basePath}/assignee`, payload),
  deleteAssignee: (payload: IDeleteUserAssigneePayload): Promise<IUserAssignee> =>
    axios.delete(`${basePath}/assignee/${payload.id}`),
};
